export default "__VITE_ASSET__BvazsYcX__"